import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Download, Smartphone } from 'lucide-react';

const PLAY_STORE_URL =
  process.env.REACT_APP_PLAY_STORE_URL ||
  'https://play.google.com/store/apps/details?id=com.Polystox.Polystox';

const APK_DOWNLOAD_URL = process.env.REACT_APP_ANDROID_APK_URL || '/app-release.apk';

const renderGooglePlayBadge = () => {
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download from Play Store"
      className="text-decoration-none"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        width: 200,
        height: 48,
        padding: '6px 12px',
        color: '#fff',
        backgroundColor: '#050505',
        border: '1px solid #2F2F2F',
        borderRadius: 8,
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.18)',
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'relative',
          display: 'inline-block',
          width: 0,
          height: 0,
          borderTop: '12px solid transparent',
          borderBottom: '12px solid transparent',
          borderLeft: '22px solid #34A853',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: -12,
            left: -22,
            width: 0,
            height: 0,
            borderTop: '12px solid transparent',
            borderBottom: '12px solid transparent',
            borderLeft: '22px solid #4285F4',
            clipPath: 'polygon(0 0, 100% 50%, 0 50%)',
          }}
        />
        <span
          style={{
            position: 'absolute',
            top: -12,
            left: -22,
            width: 0,
            height: 0,
            borderTop: '12px solid transparent',
            borderBottom: '12px solid transparent',
            borderLeft: '22px solid #FBBC04',
            clipPath: 'polygon(0 50%, 100% 50%, 0 100%)',
          }}
        />
        <span
          style={{
            position: 'absolute',
            top: -6,
            left: -5,
            width: 0,
            height: 0,
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderLeft: '10px solid #EA4335',
          }}
        />
      </span>
      <span className="d-flex flex-column lh-1">
        <span
          style={{
            fontSize: 9,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            marginBottom: 5,
          }}
        >
          GET IT ON
        </span>
        <span style={{ fontSize: 19, fontWeight: 600, letterSpacing: 0 }}>
          Google Play
        </span>
      </span>
    </a>
  );
};

const DownloadAPK = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = APK_DOWNLOAD_URL;
    link.download = 'app-release.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="p-4">
      <Card className="border shadow-none">
        <CardBody className="p-4">
          <div className="d-flex align-items-start gap-3 mb-4">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-light text-primary"
              style={{ width: 44, height: 44 }}
            >
              <Smartphone size={22} />
            </div>
            <div>
              <h4 className="f-18 fw-semibold mb-2">Download Polystox App</h4>
              <p className="text-muted mb-0" style={{ maxWidth: 720 }}>
                Choose how users can install the Android app. Use direct APK
                download for manual installs, or Play Store for trusted updates.
              </p>
            </div>
          </div>

          <div className="border rounded p-3 text-center">
            <div className="d-flex flex-wrap align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={handleDownload}
                className="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2"
                style={{
                  width: 200,
                  height: 48,
                  fontSize: 15,
                  borderRadius: 4,
                }}
              >
                <Download size={16} />
                Download APK
              </button>
              {renderGooglePlayBadge()}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default DownloadAPK;
